import { render, staticRenderFns } from "./companyDetail.vue?vue&type=template&id=128582c1&scoped=true"
import script from "./companyDetail.vue?vue&type=script&lang=js"
export * from "./companyDetail.vue?vue&type=script&lang=js"
import style0 from "./companyDetail.vue?vue&type=style&index=0&id=128582c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128582c1",
  null
  
)

export default component.exports